<template>
  <v-dialog :value="show" max-width="700px" persistent scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">{{ userId ? "Менеджер" : "Новый менеджер" }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.login"
                label="Логин"
                :disabled="!!userId"
                :error-messages="modelState['Login']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.firstName"
                label="Имя"
                :error-messages="modelState['FirstName']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.lastName"
                label="Фамилия"
                :error-messages="modelState['LastName']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.phoneNumber"
                label="Номер телефона"
                :error-messages="modelState['PhoneNumber']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.whatsAppPhoneNumber"
                label="Номер телефона в WhatsApp"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.whatsAppLink"
                label="Ссылка для номера в WhatsApp"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.email"
                label="Email почта"
              ></v-text-field>
            </v-col>
            <template v-if="!userId">
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.password"
                  type="password"
                  label="Пароль"
                  :error-messages="modelState['Password']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.confirmPassword"
                  type="password"
                  label="Подтвердите пароль"
                  :error-messages="modelState['ConfirmPassword']"
                ></v-text-field>
              </v-col>
            </template>
            <v-col cols="12" sm="6" v-else>
              <v-switch v-model="form.isActive" label="Активен"></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="Close">Отмена</v-btn>
        <v-btn text @click="Save">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
    userId: { type: String, default: null },
    prefill: { type: Object, default: () => ({}) },
  },
  data: () => ({
    form: {},
    modelState: {},
  }),
  watch: {
    show(val) {
      if (!val) return;

      this.modelState = {};

      if (this.userId) {
        this.$store
          .dispatch("GET_MANAGER_FOR_EDIT", this.userId)
          .then((data) => {
            this.form = Object.assign({}, data);
          })
          .catch((error) => {
            this.ShowError(error);
            this.Close();
          });
      } else {
        this.form = {
          login: this.prefill.login || "",
          firstName: this.prefill.firstName || "",
          lastName: this.prefill.lastName || "",
          phoneNumber: "",
          whatsAppPhoneNumber: "",
          whatsAppLink: "",
          email: "",
          password: "",
          confirmPassword: "",
        };
      }
    },
  },
  methods: {
    Save() {
      this.modelState = {};

      const action = this.userId ? "UPDATE_MANAGER" : "CREATE_MANAGER";

      this.$store
        .dispatch(action, this.form)
        .then(() => {
          this.$store.commit("SET_SNACKBAR", {
            text: this.userId
              ? "Менеджер успешно обновлен!"
              : "Менеджер успешно создан!",
            timeout: 5000,
            color: "success",
            show: true,
          });
          this.$emit("saved");
        })
        .catch((error) => {
          if (error.response?.data?.errors) {
            this.modelState = error.response.data.errors;
          } else {
            this.ShowError(error);
          }
        });
    },
    Close() {
      this.$emit("close");
    },
    ShowError(error) {
      if (error.response?.data?.error) {
        this.$store.commit("SET_SNACKBAR", {
          text: error.response.data.error,
          timeout: 5000,
          color: "error",
          show: true,
        });
      }
      window.console.log(error);
    },
  },
};
</script>
